export default "__VITE_ASSET__CutMxeqX__"